<template>
  <div
    class="winners-wrapper"
    :class="siteVariant"
  >
    <IntroTitle :site-variant="siteVariant">
      <div class="congrats">
        <h2>
          Congratulations Winners!
        </h2>
        <p>
          National Finalists will compete for national honors, {{
            siteVariant === 'acura' ? 'COSE' : 'COSL'
          }} Sales
          Credits and cash prizes in Las Vegas June {{
            siteVariant === 'acura' ? '16-18' : '18-20'
          }}, 2025.*
        </p>
      </div>
    </IntroTitle>
    <section class="finalists">
      <TheLoading v-if="loadingNational" />
      <FinalistCards v-else :finalists="nationalFinalists"/>
    </section>
    <section class="winners">
      <TheLoading v-if="loadingZone" />
      <WinnersCards v-else :winners="zoneWinners"/>
    </section>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import IntroTitle from '@/components/intro/IntroTitle.vue';
import FinalistCards from '@/components/FinalistCards.vue';
import WinnersCards from '@/components/WinnersCards.vue';
import { useToast } from 'vue-toastification';
import api from '@/api';
import TheLoading from '@/components/TheLoading.vue';

const props = defineProps({
  siteVariant: String,
});

const toast = useToast();

const loadingNational = ref(false);
const loadingZone = ref(false);
const nationalFinalists = ref([]);
const zoneWinners = ref([]);

const fetchZoneWinners = async () => {
  loadingZone.value = true;
  try {
    const { data } = await api.data.getZoneWinners(props.siteVariant);
    zoneWinners.value = data;
  } catch {
    toast.error('An error ocurred while fetching zone finalists. Please try again.');
  } finally {
    loadingZone.value = false;
  }
};

const fetchNationalFinalists = async () => {
  loadingNational.value = true;
  try {
    const { data } = await api.data.getNationalFinalists(props.siteVariant);
    nationalFinalists.value = data;
  } catch {
    toast.error('An error ocurred while fetching national finalists. Please try again.');
  } finally {
    loadingNational.value = false;
  }
};

onMounted(() => {
  fetchZoneWinners();
  fetchNationalFinalists();
});
</script>

<style scoped lang="scss">
.winners-wrapper {
  margin-bottom: 45px;
  position: relative;
  z-index: 1;
}

.congrats {
  padding: 20px 0 30px;
  color: $AC_White;
  max-width: 1640px;
  margin: 0 auto;
  position: relative;
  z-index: 1;

  @media (min-width: 641px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media (min-width: 1025px) {
    padding-top: 40px;
    padding-bottom: 50px;
  }

  h2 {
    font-size: clamp(30px, 104px, 5.45vw);
    letter-spacing: 0.75px;
    line-height: 1;
    text-transform: uppercase;
    margin-bottom: 20px;
  }

  p {
    font-size: clamp(20px, 50px, 2.65vw);
    letter-spacing: 0.5px;
    line-height: 1.4;
  }
}

.finalists,
.winners {
  padding: 15px;

  :deep(.cards) {
    background-color: $AC_Navy;
    border: 2px solid $AC_Orange;
    border-radius: 10px;
    box-shadow: 0 0 20px $AC_Orange;
    color: $AC_White;
    padding-top: clamp(20px, 38px, 3vw);
    padding-bottom: clamp(20px, 38px, 3vw);
    padding-left: clamp(16px, 50px, 3vw);
    padding-right: clamp(16px, 50px, 3vw);
    max-width: 1552px;
    margin: 0 auto;

    h3 {
      font-size: clamp(24px, 60px, 3.2vw);
      letter-spacing: 0.75px;
      line-height: 1;
      text-transform: uppercase;
      margin-bottom: 25px;

      @media (min-width: 1025px) {
        margin-bottom: 35px;
      }
    }
  }
}

.finalists {
  @media (min-width: 641px) {
    position: relative;
  }
}

.winners {
  margin-top: 30px;

  :deep(.cards) {
    h3 {
      @media (min-width: 1281px) {
        margin-bottom: 50px;
      }

      @media (min-width: 1600px) {
        margin-bottom: 80px;
      }
    }
  }
}

:deep(.loader__msg) {
  color: $AC_White;
}

.acura {
  .congrats {
    h2 {
      font-family: 'Avenir Heavy';
    }

    p {
      font-family: 'Avenir';
      font-weight: 300;
    }
  }

  .finalists,
  .winners {
    :deep(h3) {
      font-family: 'Avenir';
      font-weight: 300;
    }
  }
}

.honda {
  .congrats {
    h2 {
      font-family: 'Myriad Pro';
      font-weight: 700;
    }

    p {
      font-family: 'Myriad Pro';
      font-weight: 300;
    }
  }

  .finalists,
  .winners {
    :deep(h3) {
      font-family: 'Myriad Pro';
      font-weight: 300;
    }
  }
}
</style>
